import React from "react"

import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const BulkResultsKeepOpenBannerComponent: React.FunctionComponent<
    IBulkResultsKeepOpenBannerComponentProps
> = props => {
    return (
        <div
            role="status"
            className={`
                flex max-w-[760px] items-start gap-[12px] rounded-[12px]
                border border-solid border-brand-warningYellow/70
                bg-brand-warningYellow/20 px-[16px] py-[14px]
                ${props.className || ""}
            `}
        >
            <FontAwesomeIcon
                aria-hidden
                icon={faTriangleExclamation}
                className="mt-[3px] shrink-0 text-[18px] text-brand-orange"
            />

            <PrimaryText>
                <span className="block text-bold">
                    Keep this page open until all checks finish
                </span>

                <span className="mt-[4px] block">
                    If you leave or refresh, you won&apos;t be able to return to
                    these live results. Final results will be available in
                    Reports.
                </span>
            </PrimaryText>
        </div>
    )
}

interface IBulkResultsKeepOpenBannerComponentProps {
    className?: string
}
